import { translateFunc } from "client/utils/translateFunc";
import { Input } from "components/common/Input/Input";
import { ChangeEvent } from "react";
import { useLeft } from "./useLeft";

export interface TopProps {
    imageId: string;
    handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const Left = ({ imageId, handleChange }: TopProps) => {
    const { left } = useLeft(imageId);

    return (
        <div className="">
            <div className="capitalize mb-2">{translateFunc("position")} (X)</div>
            <Input
                className="w-full"
                type="number"
                min={0}
                value={Math.round(left)}
                onChange={handleChange}
                data-testid="crop-settings-left"
            />
        </div>
    );
};
